var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhoneNoCallIcon = function SvgPhoneNoCallIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(-1167 -271)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 24,
    height: 24,
    rx: 3,
    transform: "translate(1167 271)",
    fill: "#f4f4f6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "call_FILL0_wght300_GRAD-25_opsz20",
    d: "M186.463-771.954a14.831,14.831,0,0,1-5.267-1.47,16.86,16.86,0,0,1-4.606-3.318,16.518,16.518,0,0,1-3.287-4.59,15.458,15.458,0,0,1-1.468-5.254,1.163,1.163,0,0,1,.313-.934,1.184,1.184,0,0,1,.913-.4h2.566a1.218,1.218,0,0,1,.8.266,1.467,1.467,0,0,1,.467.734l.543,2.089a1.175,1.175,0,0,1-.046.619,1.294,1.294,0,0,1-.323.535l-2.343,2.295A18.164,18.164,0,0,0,176-779.346a14.557,14.557,0,0,0,1.511,1.768,15.293,15.293,0,0,0,1.763,1.518,16.258,16.258,0,0,0,2.076,1.3l2.483-2.4a.917.917,0,0,1,.423-.272,1.39,1.39,0,0,1,.537-.013l2.015.436a1.317,1.317,0,0,1,.748.471,1.329,1.329,0,0,1,.275.84v2.525a1.168,1.168,0,0,1-.412.912A1.207,1.207,0,0,1,186.463-771.954ZM174.157-782.6l1.958-1.878a.2.2,0,0,0,.06-.11.284.284,0,0,0,0-.13l-.469-1.8a.214.214,0,0,0-.07-.12.2.2,0,0,0-.13-.04h-2.23a.134.134,0,0,0-.1.04.14.14,0,0,0-.037.1,9.414,9.414,0,0,0,.336,1.958A17.484,17.484,0,0,0,174.157-782.6Zm8.464,8.4a9.4,9.4,0,0,0,1.932.623q1.018.212,1.891.312a.136.136,0,0,0,.1-.04.135.135,0,0,0,.04-.1v-2.238a.2.2,0,0,0-.04-.13.214.214,0,0,0-.12-.07l-1.646-.379a.188.188,0,0,0-.1,0,.28.28,0,0,0-.095.06ZM174.157-782.6ZM182.621-774.193Z",
    transform: "translate(999.171 1062.935)",
    fill: "#3b3b3b"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneNoCallIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phoneNoCallIcon.01cac6bc.svg";
export { ForwardRef as ReactComponent };